export default "__VITE_ASSET__ypFoX73y__"